module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phead9-0459dbabb2002746b19a1f8ed19d8c46.jpg";